import { useMutation } from 'react-apollo';
import gql from 'graphql-tag';
export function useListFilter(args) {
    const [toggleActiveMutation] = useMutation(gql `
    mutation toggleActiveListItem(
      $value: String!
      $parentId: String!
      $set: Boolean
    ) {
      toggleListFilterItem(value: $value, parentId: $parentId, set: $set)
        @client {
        isActive @client
      }
    }
  `);
    const [clearFilterMutation] = useMutation(gql `
    mutation ClearListFilter($id: String!) {
      clearListFilter(id: $id) @client
    }
  `);
    function clear() {
        const filter = args.filter;
        return clearFilterMutation({ variables: { id: filter.id } });
    }
    function apply({ value, set }) {
        const filter = args.filter;
        // Update filters in the client state
        return toggleActiveMutation({
            variables: {
                parentId: filter.id,
                value,
                set
            }
        });
    }
    return { apply, clear };
}
//# sourceMappingURL=useListFilter.js.map